// angular.module('TextFilters', [])
angular.module('Filters')
.filter('replaceUnderscores', function () {
  return function(name) {
    if (angular.isDefined(name)){
      return name.replace(/_/g, " ");
    }
  };
});